import TextWithImages from "./TextWithImages";
export default TextWithImages;
